import React from "react";
import PostCard from "./PostCard";

/**
 * FeedItem — enhetlig post-renderer for /beta-feed.
 * For profile_post delegerer vi til PostCard (konsistent interaksjon:
 * reaksjoner, kommentarer, rediger, rapporter).
 */
export default function FeedItem({ item }) {
  if (item?.type !== "profile_post") {
    // Fremtidige typer kan rendres her
    return null;
  }
  // Map feed-item-shape → PostCard-shape
  const post = {
    id: item.id,
    author: item.author,
    text: item.content?.text,
    media: item.content?.media,
    visibility: item.content?.visibility,
    comments_disabled: item.content?.comments_disabled || item.comments_disabled || false,
    edited: item.content?.edited,
    promo: item.content?.promo || null,
    created_at: item.created_at,
    reactions_count: item.reactions_count || 0,
    my_reaction: item.my_reaction || null,
    comments_count: item.comments_count || 0,
  };
  return <PostCard post={post} />;
}
